import {
  animate,
  ViewOpts,
  ImageView,
  View,
  ImageSliceView,
} from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { downscale } from 'src/conf/scale';

/**
 * Show tutorial tip view with a message and a animated pointer
 */
export class TutorialBlockTipView extends View {
  private panel: ImageView;
  private pointer: ImageView;
  private message: LangBitmapFontTextView;
  private time = 0;

  constructor(superView: View, opts: ViewOpts = {}) {
    super({
      visible: false,
      superview: superView,
      ...opts,
    });

    this.panel = new ImageView({
      superview: this,
      image: 'assets/tutorial/revamp/tutorial_tip.png',
      width: downscale(897),
      height: downscale(264),
      centerOnOrigin: true,
    });

    this.message = new LangBitmapFontTextView({
      superview: this.panel,
      font: 'Body',
      color: '#7A674F',
      size: 30,
      localeText: () => 'TITLE',
      width: 490,
      height: 100,
      align: 'center',
      verticalAlign: 'center',
      x: (this.panel.style.width - 490) * 0.5,
      y: 30,
      wordWrap: true,
    });

    this.pointer = new ImageView({
      superview: this,
      image: 'assets/tutorial/hand/tutorial_hand.png',
      width: 96,
      height: 80,
      centerOnOrigin: true,
      scaleX: 0,
      scaleY: 0,
    });
  }

  /**
   * Show tip popup with a message and a pointer
   *
   * @param text Text to show
   * @param position Position of the tip popup
   * @param pointer Position of the animated pointer
   */
  public showTip(
    text: string,
    position: { x: number; y: number },
    pointer: { x: number; y: number },
  ) {
    this.message.localeText = () => text;

    this.panel.updateOpts({
      x: this.style.width / 2 + position.x,
      y: position.y,
    });

    this.pointer.updateOpts(pointer);

    void this.animateShow();
  }

  /**
   * Hide tip popup
   */
  public async hideTip() {
    animate(this.panel)
      .now({ opacity: 1 })
      .then({ opacity: 0, offsetY: -400 }, 300, animate.easeInCubic);

    return animate(this.pointer)
      .now({ opacity: 1 })
      .then({ opacity: 0 }, 300, animate.easeInCubic)
      .then(() => this.hide())
      .toPromise();
  }

  /**
   * Update the pointer position on every tick
   */
  public tick(dt: number) {
    this.time += dt;
    this.pointer.updateOpts({
      offsetY: Math.abs(Math.sin(this.time * 0.005) * 30),
    });
  }

  /**
   * Show animation for the tip popup
   */
  private async animateShow() {
    animate(this.panel)
      .now({ scaleY: 0 })
      .then({ scaleY: 1 }, 400, animate.easeOutBack);

    return animate(this.pointer)
      .now({ scaleX: 0, scaleY: 0 })
      .then(() => this.show())
      .then({ scaleX: 1, scaleY: 1 }, 400, animate.easeOutBack)
      .toPromise();
  }
}
